import { useEffect } from 'react';

import * as analytics from 'utilities/analytics';

export const AnalyticsTrackPageWrapper = ({
  children,
  pageName,
  props = {},
}) => {
  useEffect(() => {
    props.is_logged_in = window.loomSSRUser !== undefined;
    props.organization_id = window.loomSSRUser?.workspaceId;
    analytics.page(pageName, props);
  }, [pageName, props]);

  return children;
};
